import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ImportTypesEnum } from './../enums/import-type.enum';

import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HeaderErrorEnum } from '../enums/header-error.enum';
import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { IImportData } from '../interfaces/data-import.interface';

@Injectable({
    providedIn: 'root',
})
export class DataImportService {
    constructor(private http: HttpClient) {}

    public importData(payload: IImportData): Observable<any> {
        let route: SubUrlsEnum;
        switch (payload.dataType) {
            case ImportTypesEnum.WALLETS:
                route = SubUrlsEnum.IMPORT_WALLET;
                break;
            case ImportTypesEnum.USERS:
                route = SubUrlsEnum.IMPORT_USERS;
                break;
        }

        const httpOptions: any = {
            headers: new HttpHeaders({
                ['Content-Type']: 'multipart/form-data',
                [HeaderErrorEnum.OWN_ERROR]: 'true',
            }),
        };

        const formData: FormData = new FormData();
        formData.append('file', payload.file);
        if (payload.schoolId) {
            formData.append('school_id', payload.schoolId.toString());
        }

        return this.http.post<any>(environment.wasoApi + route, formData, httpOptions).pipe(
            map((response: any) => {
                console.log(response);
            })
        );
    }
}
